// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fic-screen {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fic-screen/fic-screen.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AACJ","sourcesContent":["fic-screen {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    overflow: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
